import React, {Component} from 'react';
import "../../ImpedanceCalculator/ImpedenceCustomization/CustomizationPage.css";
import impedance1 from "../../../../../assets/img/imp1.jpg";
import impedance2 from "../../../../../assets/img/imp2.jpg";

class ImpedancePreview extends Component {

    render() {
        return (

            <div className="impedance-preview-div ">
                <div className="row">
                    <div className="col-md-6"><b>Type of impedance</b></div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <div className="row">
                            <br/>
                            <h6>Order selection:JLC7628</h6>
                            <br/>
                            <img src={impedance1} className="imp-img"/>
                        </div>
                        <div className="row">
                            <br/>
                            <h6>Order selection:JLC2313</h6>
                            <br/>
                            <img src={impedance2} className="imp-img"/>
                        </div>


                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <b>H1：7.10</b><br/>
                            <b>T1：1.40</b><br/>
                            <b>C2：0.50</b><br/>
                        </div>
                        <div className="row">
                            <br/><br/><br/><br/><br/><br/>
                            <b>Er1：4.60</b><br/>
                            <b>TC1：0.80</b><br/>
                            <b>CEr：3.80</b><br/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <b>H1：7.10</b><br/>
                            <b>T1：1.40</b><br/>
                            <b>C2：0.50</b><br/>
                        </div>
                        <div className="row">
                            <br/><br/><br/><br/><br/><br/>
                            <b>Er1：4.60</b><br/>
                            <b>TC1：0.80</b><br/>
                            <b>CEr：3.80</b><br/>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>

            </div>

        );
    }

}
export  default ImpedancePreview;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/ImpedanceCalculator/ImpedencePreview/ImpedancePreview.js